import CompoundTable from "@/components/CompoundTable.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import LoadingElement from "@/components/shared/LoadingElement.vue";
import { OverlapBarValue, HugValue, DottedValue, DateValue, CurrencyValue, PercentageValue, BoxedValue, BarWithValue, ValueElement, NumberValue, WrapWithArrow } from "@/components/tableElements";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import AppIcon from "@/components/AppIcon.vue";
import { EVENTS, KPI_DIRECTION_TYPE, CVR_HEATMAP_COLORS, CPC_DECILE_COLORS, BEST_POSITION_HEATMAP_COLORS, PERIOD_COLUMN_TITLES, DEFAULT_DATE_FORMATS } from "@/utils/constants";
import { generateColorBasedOnState, getColorsBasedOnRange, getColorForDecile, getDescriptionBasedOnKpiKey, transformGoogleSheetFromCSV } from "@/utils/transformers";
import { mapState, mapGetters } from "vuex";
import { SELECTOR, PERIOD_FIELD, TACOS_FIELD, SPEND_FIELD, SPONSORED_SALES_FIELD, CLICKS_FIELD, CPC_FIELD, BAR_ROAS_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, PPC_V2_PERIOD_FIELD, CTR_FIELD, IMPRESSIONS_FIELD } from "@/utils/table_fields";
import FlexRow from "@/components/FlexRow.vue";
import FilterDivider from "@/components/new-filters/FilterDivider.vue";
import AppIconGroup from "@/components/AppIconGroup";
import DownloadMixin from "@/mixins/DownloadMixin.vue";
import { capitalize } from "vue";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import ViewExportDropdown from "@/components/ViewExportDropdown.vue";
import TasksMixin from "@/mixins/TasksMixin.vue";
import WrapTableWithShowMore from "@/components/WrapTableWithShowMore.vue";
export default {
  name: "PerformancePeriodTable",
  components: {
    CompoundTable,
    DottedValue,
    DateValue,
    CurrencyValue,
    PercentageValue,
    BoxedValue,
    ValueElement,
    NumberValue,
    BarWithValue,
    WrapWithPopover,
    WrapWithArrow,
    LoadingElement,
    OverlapBarValue,
    HugValue,
    AppIcon,
    FlexRow,
    FilterDivider,
    AppIconGroup,
    SlotWithEvolutionValue,
    EvolutionValue,
    ViewExportDropdown,
    WrapTableWithShowMore
  },
  emits: ["refresh", "setDateRange"],
  mixins: [LiteTableMixin, DownloadMixin, TasksMixin],
  props: {
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      KPI_DIRECTION_TYPE,
      showShadow: false,
      CVR_HEATMAP_COLORS,
      CPC_DECILE_COLORS,
      BEST_POSITION_HEATMAP_COLORS,
      fieldsSources: {
        DEFAULT_FIELDS: [SELECTOR, PERIOD_FIELD, SPONSORED_SALES_FIELD, SPEND_FIELD, TACOS_FIELD, IMPRESSIONS_FIELD, CTR_FIELD, CLICKS_FIELD, CPC_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, BAR_ROAS_FIELD],
        TARGETING_FIELDS: [SELECTOR, PERIOD_FIELD, SPONSORED_SALES_FIELD, SPEND_FIELD, IMPRESSIONS_FIELD, CTR_FIELD, CLICKS_FIELD, CPC_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, BAR_ROAS_FIELD]
      },
      csvSources: period => ({
        DEFAULT_FIELDS: {
          [PERIOD_COLUMN_TITLES[period]]: PPC_V2_PERIOD_FIELD.key,
          [SPONSORED_SALES_FIELD.label]: SPONSORED_SALES_FIELD.key,
          [SPEND_FIELD.label]: SPEND_FIELD.key,
          [TACOS_FIELD.label]: TACOS_FIELD.key,
          [IMPRESSIONS_FIELD.label]: IMPRESSIONS_FIELD.key,
          [CTR_FIELD.label]: CTR_FIELD.key,
          [CLICKS_FIELD.label]: CLICKS_FIELD.key,
          [CPC_FIELD.label]: CPC_FIELD.key,
          [UNITS_SOLD_FIELD.label]: UNITS_SOLD_FIELD.key,
          [CVR_FIELD.label]: CVR_FIELD.key,
          [BAR_ROAS_FIELD.label]: BAR_ROAS_FIELD.key
        },
        TARGETING_FIELDS: {
          [PERIOD_COLUMN_TITLES[period]]: PPC_V2_PERIOD_FIELD.key,
          [SPONSORED_SALES_FIELD.label]: SPONSORED_SALES_FIELD.key,
          [SPEND_FIELD.label]: SPEND_FIELD.key,
          [IMPRESSIONS_FIELD.label]: IMPRESSIONS_FIELD.key,
          [CTR_FIELD.label]: CTR_FIELD.key,
          [CLICKS_FIELD.label]: CLICKS_FIELD.key,
          [CPC_FIELD.label]: CPC_FIELD.key,
          [UNITS_SOLD_FIELD.label]: UNITS_SOLD_FIELD.key,
          [CVR_FIELD.label]: CVR_FIELD.key,
          [BAR_ROAS_FIELD.label]: BAR_ROAS_FIELD.key
        }
      })
    };
  },
  mounted() {
    //console.log('ppc_v2', this.periodCategory);
    this.marketplaces_filter._key = "sales_channel";
  },
  computed: {
    ...mapState({
      periodTable: state => state.ppc_v2.periodTable,
      period: state => state.ppc_v2.period,
      tab: state => state.ppc_v2.currentTabValue,
      marketplaces_filter: state => state.ppc_v2.marketplaces_filter,
      periodCategory: state => state.ppc_v2.periodCategory,
      period_page: state => state.ppc_v2.period_page
    }),
    ...mapGetters(["ppcV2SecondaryFiltersEnabled", "ppcV2SecondaryFields"]),
    items() {
      //console.log("this.periodTable", this.periodTable);
      return this.periodTable[this.tab].items;
    },
    maxCharCount() {
      return this.periodTable[this.tab].maxCharCount;
    },
    minMax() {
      return this.periodTable[this.tab].minMax;
    },
    periodTitle() {
      return this.periodTable[this.tab].title[this.period];
    },
    getPeriodColumnTitle() {
      return PERIOD_COLUMN_TITLES[this.period];
    },
    in_currency() {
      return this.$store.getters.currencyConfigInCurrencyGet();
    },
    getDateValueFormat() {
      // Convert the current period to UPPER CASE
      const period = this.period.toUpperCase();
      return DEFAULT_DATE_FORMATS[period];
    },
    fields() {
      return this.fieldsSources[this.ppcV2SecondaryFields()];
    },
    csvFileName() {
      return `PPC_V2_Performance_Evolution_${capitalize(this.period)}.csv`;
    },
    period_pager: {
      get() {
        return this.periodTable.period_page;
      },
      set(_) {
        this.$store.dispatch('ppcV2IncrementPeriodPage');
        this.$emit('refresh');
      }
    }
  },
  methods: {
    generateColorBasedOnState,
    getColorsBasedOnRange,
    getColorForDecile,
    getDescriptionBasedOnKpiKey,
    getMinForColumn(column) {
      return this.minMax[column]?.min;
    },
    getMaxForColumn(column) {
      return this.minMax[column]?.max;
    },
    handleDateClick(period) {
      window.$bus.trigger(EVENTS.OPEN_PRODUCT_TABLE_COLLAPSE);
      this.$emit("setDateRange", period);
    },
    handleDateReset() {
      this.$emit("setDateRange", null);
    },
    activateDateValueStyles(row) {
      return row.item.selected ? {
        color: "#312783",
        fontWeight: "600"
      } : {};
    },
    handleRefresh() {
      this.$emit("refresh");
    },
    handleRefreshDatePicker() {
      this.$emit("refresh:datePicker");
    },
    async copyPerformancePeriodCSV() {
      const csv_headers = this.csvSources(this.period)[this.ppcV2SecondaryFields()];
      const str = await this.generateCsvString(csv_headers, this.prepareCsvRowsForDownload(this.items, csv_headers), 1, "-");
      await this.copyCSV(str);
    },
    async downloadPerformancePeriodCSV() {
      const csv_headers = this.csvSources(this.period)[this.ppcV2SecondaryFields()];
      const csvFileName = this.csvFileName;
      const str = await this.generateCsvString(csv_headers, this.prepareCsvRowsForDownload(this.items, csv_headers), 1, "-");
      await this.downloadCsv(str, csvFileName);
      this.trackAdvertisingCsvExport();
    },
    async downloadPerformanceGoogleSheet() {
      const csv_headers = this.csvSources(this.period)[this.ppcV2SecondaryFields()];
      const rowData = this.prepareCsvRowsForDownload(this.items, csv_headers);
      const data = transformGoogleSheetFromCSV(csv_headers, rowData);
      const task = await this.downloadCSVWithGoogleSheets('/ppc/v2/generate/googlesheet', {
        sheet_name: this.csvFileName,
        task_type: "google_sheet_generation",
        data
      });

      //console.log('ppc google sheet task', task);

      if (!task) {
        return;
      }
      this.sheetGenerationTaskIdentifier = task.task_id;
      this.executeTaskStatusHandler(task);
      this.checkTaskStatusPeriodically(this.sheetGenerationTaskIdentifier);
    },
    handleRunning() {
      this.checkTaskStatusPeriodically(this.sheetGenerationTaskIdentifier);
    },
    handleFailed(data) {
      this.exportLoading = false;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showDanger", {
        visible: true,
        message: "Google sheet generation Task failed \n" + data.task_result,
        delay: 60 // Show alert less than 60 secs
      });
      throw new Error("Google sheet generation Task failed");
    },
    async handleFinished(data) {
      //console.log('dashboard finished', data);
      if (data) {
        const {
          task_result: {
            share_link
          }
        } = data;
        if (this.asyncUpdateInterval) {
          clearTimeout(this.asyncUpdateInterval);
          this.asyncUpdateInterval = null;
        }
        window.$bus.trigger("showSuccess", {
          visible: true,
          message: "The google sheet has been successfully generated. A link has been sent to your email.",
          delay: 60 // Show alert less than 60 secs
        });
        this.exportLoading = false;
        if (share_link) window.open(share_link, "_blank");
      }
    }
  }
};